import { Content, Header, HeaderDescription, Root } from './layout.parts';

export const Layout = {
  Header: Header,
  HeaderDescription: HeaderDescription,
  Content: Content,
  Root: Root,
};
